(() => {
 const root=document.querySelector('.mxpro-header'); if(!root)return;
 root.querySelectorAll('.mx-nav__group').forEach(item=>item.addEventListener('toggle',()=>{
   if(item.open) item.closest('.mx-nav').querySelectorAll('.mx-nav__group').forEach(other=>{if(other!==item)other.open=false;});
 }));
 document.addEventListener('click',event=>{if(!root.contains(event.target))root.querySelectorAll('details[open]').forEach(d=>d.open=false);});
 root.addEventListener('keydown',event=>{
   if(event.key!=='Escape')return;
   const open=event.target.closest('details[open]')||root.querySelector('details[open]');
   if(open){open.open=false;open.querySelector('summary').focus();event.preventDefault();event.stopPropagation();}
 });
})();
(() => {
 const bind = container => {
  if(container.dataset.mxRequired)return;
  container.dataset.mxRequired='true';
  const fields=()=>Array.from(container.querySelectorAll('select'));
  const update=()=>{const button=container.querySelector('.easysearch-btn-search');if(button)button.setAttribute('aria-disabled',String(fields().some(s=>!s.value||s.disabled)));};
  container.addEventListener('change',update);
  container.addEventListener('click',event=>{if(!event.target.closest('.easysearch-btn-search'))return;const empty=fields().find(s=>!s.value||s.disabled);if(empty){event.preventDefault();event.stopImmediatePropagation();fields().find(s=>!s.value&&!s.disabled)?.focus();}},true);
  new MutationObserver(update).observe(container,{childList:true,subtree:true});update();
 };
 const scan=()=>document.querySelectorAll('.easysearch-container').forEach(bind);
 scan();new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
})();
